import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import { SnackbarProvider } from 'notistack';

import Main from './layout/Main';
import Login from './pages/login/Login';
import SignUp from './pages/signup/SignUp';
import SOSAlertDialog from './components/alerts/SOSAlertDialog';
import { lightTheme } from './theme/lightTheme';

import './App.css';
import 'leaflet/dist/leaflet.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      {/* <ToastContainer /> */}
      <ThemeProvider theme={lightTheme}>
        <SnackbarProvider maxSnack={5}>
          {/* <SOSAlertDialog /> */}
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/*" element={<Main />} />
          </Routes>
        </SnackbarProvider>

      </ThemeProvider>
    </div>
  );
}

export default App;